import { fetchGetCompanySubsidiaries } from "../../../services/api"
import { useEffect, useState } from "react"

export default function ContactUsMapArea({ company }) {

    const [subsidiaries, setSubsidiaries] = useState([])

    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet
                }))
                setSubsidiaries(subs)
            })
    }, [])

    return (
        <div className="map-area mb-60">
            <h4 className="map-title text-black">Loja 1:<span style={{ color: "#575757" }}>{company.address} - {company.city} - {company.federativeUnit} - {company.postalCode}</span> </h4>
            <iframe
                src={`https://maps.google.com/maps?q=${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                width="100%"
                height="480"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"></iframe>
            {subsidiaries.length > 0 && subsidiaries.map((item, index) => (
                <div key={index} className="map-area mt-60">
                    <h4 className="map-title text-black">
                        Loja {index + 2}: <span style={{ color: "#575757" }}>{item.address} - {item.city} - {item.federativeUnit} - {item.postalCode} </span>
                    </h4>

                    <iframe
                        src={`https://maps.google.com/maps?q=${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
                        width="100%"
                        height="480"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                    />
                </div>
            ))}
        </div>
    )
}